import { render, staticRenderFns } from "./sponsor-slide.vue?vue&type=template&id=5d9f5377&scoped=true&"
import script from "./sponsor-slide.vue?vue&type=script&lang=js&"
export * from "./sponsor-slide.vue?vue&type=script&lang=js&"
import style0 from "./sponsor-slide.vue?vue&type=style&index=0&id=5d9f5377&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9f5377",
  null
  
)

export default component.exports